import { mapState, mapActions } from "vuex";

export const dragAndDrop = {
  data() {
    return {
      dragOver: false
    };
  },
  computed: {
    ...mapState("exchange", ["exchangeId"]),
    determineDragAndDropCapable() {
      const div = document.createElement("div");

      return (
        ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
        "FormData" in window &&
        "FileReader" in window
      );
    }
  },
  methods: {
    ...mapActions("common", ["setLoading", "showUploadModal", "showModal"]),
    ...mapActions("exchange", ["setChoosenFiles", "updateExchangeFiles"]),
    setFilesupdateExchange(dataTransfer) {
      this.showUploadModal();
      this.setLoading(true);
      this.setChoosenFiles(dataTransfer);
      let fileList = [];
      for (let i = 0; i < dataTransfer.length; i++) {
        fileList.push(dataTransfer[i]);
      }
      this.dragOver = false;
      this.updateExchangeFiles(fileList);
    },
    dragover() {
      this.dragOver = true;
    },
    dragenter() {
      this.dragOver = true;
    },
    dragleave() {
      this.dragOver = false;
    }
  },
  mounted() {
    if (this.$refs.fileform) {
      if (this.determineDragAndDropCapable) {
        [
          "drag",
          "dragstart",
          "dragend",
          "dragover",
          "dragenter",
          "dragleave",
          "drop"
        ].forEach(evt => {
          this.$refs.fileform.addEventListener(
            evt,
            e => {
              e.preventDefault();
              e.stopPropagation();
            },
            false
          );
        });

        this.$refs.fileform.addEventListener(
          "dragover",
          () => {
            this.dragOver = true;
          },
          { once: true }
        );

        this.$refs.fileform.addEventListener("dragenter", () => {
          this.dragOver = true;
        });

        this.$refs.fileform.addEventListener("dragleave", () => {
          this.dragOver = false;
        });

        this.$refs.fileform.addEventListener("drop", e => {
          const dataTransfer = e.dataTransfer.files;
          if (!this.exchangeId) {
            this.setLoading(true);
            this.$store
              .dispatch("exchange/createExchange")
              .then(() => {
                this.setLoading(false);
                this.setFilesupdateExchange(dataTransfer);
              })
              .catch(err => {
                this.setLoading(false);
                this.showModal({
                  title: err.errorCode
                });
              });
          } else {
            this.setFilesupdateExchange(dataTransfer);
          }
        });
      }
    }
  }
};
